export const SHORTLIST_STORAGE_KEY = 'shortlist';
export const SHORTLIST_PERSISTED_VERSION = 1;
export const MAX_SHORTLIST_SIZE = 9;
export const MAX_PREVIEW_AVATARS = 3;

/**
 * Dashed placeholder circles standing in for sitters before any is added.
 * Only the empty state pads its stack; a populated one shows the sitters it has.
 */
export const EMPTY_STATE_PREVIEW_AVATARS = 3;

export const MULTI_CONTACT_ROUTE = '/multi-contact-sitter/';

/**
 * DOM mount node (in the Django header) for ShortListModal.
 */
export const SHORTLIST_MODAL_SELECTOR = '#react-shortlist-modal';

/**
 * Window event dispatched by the non-React navbar button to open the modal.
 * Bridges legacy (Django/Backbone) pages to ShortListModal.
 */
export const SHORTLIST_MODAL_OPEN_EVENT = 'rover:shortlist:open';

/**
 * Window event dispatched after the persisted shortlist changes in this tab.
 * The `storage` event only fires in other tabs, so non-React listeners (the
 * Django navbar badge) need this to stay in sync with same-tab mutations.
 */
export const SHORTLIST_CHANGE_EVENT = 'rover:shortlist:change';
